module.exports = __webpack_public_path__ + "static/img/yylogo1.20869f75.png";